import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";

// Project Imports
import {
  virtuallyApproveTrainer,
  resetCurrentTrainerId,
  resetVirtualApprovalStates,
} from "../../../Actions";
import DialogContainer from "../DialogApprove";

const Step4Component = ({
  trainerData,
  handleBack,
  styleClasses,
  grayedOutStyles,
  Comment,
  handleCommentChange,
  showErr,
  showErr2,
  showErr3,
  removeErr,
  commentErr,
  textFieldName,
}) => {
  const navigate = useNavigate();
  const globalDispatch = useDispatch();

  const trainersReducer = (state) => state.trainersReducer;
  const usersReducer = (state) => state.usersReducer;

  const { authUser } = useSelector(usersReducer);
  const {
    processingVirtualApproval,
    virtualApprovalSuccess,
    currentTrainerId,
  } = useSelector(trainersReducer);

  const [userActions, setUserActions] = useState({
    approveText: "",
    disapproveText: "",
    headerText: "",
    userRole: "",
    showButtons: false,
  });
  const [approvalAction, setApprovalAction] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  useEffect(() => {
    const userRole = authUser?.role;
    if (userRole) {
      if (
        userRole === "SAED_NDHQ" &&
        trainerData?.approvalStatus?.name !== "HeadQuatersApproved"
      ) {
        setUserActions({
          approveText: "Approve",
          disapproveText: "Reject",
          headerText: trainerData?.skillCenterName,
          userRole: userRole,
          showButtons: true,
        });
      } else if (userRole !== "SAED_NDHQ") {
        setUserActions({
          approveText: "Recommend for Approval",
          disapproveText: "Recommend for Rejection",
          headerText: trainerData?.skillCenterName,
          userRole: userRole,
          showButtons: true,
        });
      }
    }
  }, [authUser]);

  useEffect(() => {
    if (virtualApprovalSuccess === true) {
      globalDispatch(resetCurrentTrainerId());
      globalDispatch(resetVirtualApprovalStates());
      navigate("/home/trainersmanagement/virtualApproval");
    }
  }, [virtualApprovalSuccess]);

  useEffect(() => {}, [trainerData]);

  function handleApproval() {
    const approvalData = {
      skillCenterId: currentTrainerId,
      isApprove: true,
      comment: Comment,
    };

    if (approvalData.skillCenterId > -1)
      globalDispatch(virtuallyApproveTrainer(approvalData));
  }

  function handleReject() {
    const rejectionData = {
      skillCenterId: currentTrainerId,
      isApprove: false,
      comment: Comment,
    };
    globalDispatch(virtuallyApproveTrainer(rejectionData));
  }

  function handleOpenConfirmDialog(actionType) {
    if (userActions?.userRole === "SAED_State") {
      if (Comment === "") {
        showErr();
      } else {
        if (Comment !== "") {
          setApprovalAction(actionType);
          setConfirmDialogOpen(true);
          removeErr();
        }
      }
    } else if (userActions?.userRole === "State Cordinator") {
      if (Comment === "") {
        showErr2();
      }
      if (textFieldName === "coordinatorComment") {
        if (trainerData?.commentByStateSaedOfficer === "" || Comment === "") {
          showErr2();
        } else {
          if (Comment !== "") {
            setApprovalAction(actionType);
            setConfirmDialogOpen(true);
            removeErr();
          }
        }
      }
    } else if (userActions?.userRole === "SAED_NDHQ") {
      if (Comment === "") {
        showErr3();
      }
      if (textFieldName === "hqComment") {
        if (trainerData?.commentByStateSaedOfficer === "") {
          showErr2();
        }
        if (trainerData?.commentByStateCordinatorOfficer === "") {
          showErr3();
        } else {
          if (Comment !== "") {
            setApprovalAction(actionType);
            setConfirmDialogOpen(true);
            removeErr();
          }
        }
      }
    }
  }

  function handleCloseConfirmDialog() {
    setConfirmDialogOpen(false);
  }

  return (
    <form style={styleClasses.formContainer}>
      <Typography variant="h6" style={styleClasses.sectionTitle}>
        Approvals
      </Typography>
      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>
          State Officer's Comment:{" "}
        </InputLabel>
        <TextField
          name="officerComment"
          variant="outlined"
          placeholder="Type your comment here"
          size="small"
          multiline={true}
          fullWidth
          value={
            trainerData?.commentByStateSaedOfficer !== "" &&
            trainerData?.commentByStateSaedOfficer !== null
              ? trainerData?.commentByStateSaedOfficer
              : Comment
          }
          onChange={handleCommentChange}
          readOnly={
            trainerData?.commentByStateSaedOfficer !== "" &&
            trainerData?.commentByStateSaedOfficer !== null
          }
          disabled={
            trainerData?.commentByStateSaedOfficer !== "" &&
            trainerData?.commentByStateSaedOfficer !== null
          }
          style={
            trainerData?.commentByStateSaedOfficer !== "" ? grayedOutStyles : {}
          }
          error={commentErr?.state}
          helperText={commentErr?.msg}
        />
      </Box>

      {trainerData?.approvalStatus.id >= 1 && (
        <Box style={styleClasses.labelContainer}>
          <InputLabel style={styleClasses.labelText}>
            State Co-ordinator's Comment:{" "}
          </InputLabel>
          <TextField
            name="coordinatorComment"
            variant="outlined"
            placeholder="Type your comment here"
            size="small"
            multiline={true}
            fullWidth
            value={
              trainerData?.commentByStateCordinatorOfficer !== "" &&
              trainerData?.commentByStateSaedOfficer !== null
                ? trainerData?.commentByStateCordinatorOfficer
                : Comment
            }
            onChange={handleCommentChange}
            readOnly={
              trainerData?.commentByStateCordinatorOfficer !== "" &&
              trainerData?.commentByStateCordinatorOfficer !== null
            }
            disabled={
              trainerData?.commentByStateCordinatorOfficer !== "" &&
              trainerData?.commentByStateCordinatorOfficer !== null
            }
            style={
              trainerData?.commentByStateCordinatorOfficer !== ""
                ? grayedOutStyles
                : {}
            }
            error={commentErr?.stateTwo}
            helperText={commentErr?.msgTwo}
          />
        </Box>
      )}

      {trainerData?.approvalStatus.id >= 2 && authUser.role === "SAED_NDHQ" && (
        <Box style={styleClasses.labelContainer}>
          <InputLabel style={styleClasses.labelText}>
            Head Quarters Comment:{" "}
          </InputLabel>
          <TextField
            name="hqComment"
            variant="outlined"
            placeholder="Type your comment here"
            size="small"
            multiline={true}
            fullWidth
            value={
              trainerData?.commentByHQOfficer !== "" &&
              trainerData?.commentByStateSaedOfficer !== null
                ? trainerData?.commentByHQOfficer
                : Comment
            }
            onChange={handleCommentChange}
            readOnly={
              trainerData?.commentByHQOfficer !== "" &&
              trainerData?.commentByHQOfficer !== null
            }
            disabled={
              trainerData?.commentByHQOfficer !== "" &&
              trainerData?.commentByHQOfficer !== null
            }
            style={
              trainerData?.commentByHQOfficer !== "" ? grayedOutStyles : {}
            }
            error={commentErr?.stateThree}
            helperText={commentErr?.msgThree}
          />
        </Box>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
        }}
      >
        <Box style={{ marginTop: "24px" }}>
          <Button variant="outlined" color="primary" onClick={handleBack}>
            Back
          </Button>
          {userActions?.showButtons && authUser.role !== "SAED_LGI" ? (
            <>
              <Button
                disableElevation
                variant="contained"
                color="primary"
                onClick={() => handleOpenConfirmDialog("approve")}
                style={{ marginLeft: "16px" }}
                disabled={processingVirtualApproval}
              >
                {approvalAction === "approve" && processingVirtualApproval ? (
                  <>
                    <CircularProgress
                      size={12}
                      sx={{ color: "white", mr: "2px" }}
                    />
                    <p> Processing </p>
                  </>
                ) : (
                  userActions.approveText
                )}
              </Button>
              <Button
                disableElevation
                variant="contained"
                onClick={() => handleOpenConfirmDialog("disapprove")}
                style={{
                  marginLeft: "16px",
                  backgroundColor: "#c31d1d",
                  color: "white",
                }}
                disabled={processingVirtualApproval}
              >
                {approvalAction === "disapprove" &&
                processingVirtualApproval === true ? (
                  <>
                    <CircularProgress
                      size={12}
                      sx={{ color: "white", mr: "2px" }}
                    />
                    <p> Processing </p>
                  </>
                ) : (
                  userActions.disapproveText
                )}
              </Button>
            </>
          ) : (
            ""
          )}
        </Box>
      </div>

      {/*  training center approve/dissapprove dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {approvalAction === "disapprove" && (
          <>
            <DialogTitle
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Public Sans, sans-serif",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                bgcolor: "#f2f2f2",
                marginBottom: "30px",
              }}
            >
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <CancelIcon sx={{ color: "#ff4d7a" }} />
                {userActions?.disapproveText + " - " + userActions?.headerText}
              </Box>
              <IconButton onClick={handleCloseConfirmDialog}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to {userActions.disapproveText}?
              </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button
                sx={{ border: "1px solid red", color: "red" }}
                variant="standard"
                onClick={handleCloseConfirmDialog}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                variant="contained"
                onClick={handleReject}
                disabled={processingVirtualApproval}
              >
                {processingVirtualApproval === true ? (
                  <>
                    <CircularProgress
                      size={12}
                      sx={{ backgroundColor: "white", mr: 12 }}
                    />
                    Processing
                  </>
                ) : (
                  userActions.disapproveText
                )}
              </Button>
            </DialogActions>
          </>
        )}

        {approvalAction === "approve" && (
          <>
            <DialogContainer
              userActions={userActions}
              handleCloseConfirmDialog={handleCloseConfirmDialog}
            />
            <DialogActions sx={{ p: 3 }}>
              <Button
                sx={{ border: "1px solid red", color: "red" }}
                variant="standard"
                onClick={handleCloseConfirmDialog}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="success"
                onClick={handleApproval}
                disabled={processingVirtualApproval}
              >
                {processingVirtualApproval === true ? (
                  <>
                    <CircularProgress
                      size={12}
                      sx={{ backgroundColor: "white", mr: 12 }}
                    />
                    Processing
                  </>
                ) : (
                  userActions.approveText
                )}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </form>
  );
};

export default Step4Component;
